import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Button, Icon, Image, Table, Card } from 'semantic-ui-react';

import { getIcon } from './ads-modal';

const ExistingAds = ({
  ads,
  unlinkAd,
}) => (
  <div>
    {
      _.isEmpty(ads) && <h2>No linked ads yet.</h2>
    }
    {
      _.map(ads, ad => {
        const campaignName = _.get(ad, 'campaignName') || _.get(ad, 'name', '-');
        const adName = _.get(ad, 'adName', '(not available)');
        return (
          <Card fluid>
            <Card.Content>
              <Table basic="very">
                <Table.Row>
                  <Table.Cell width="2">
                    <h3><Icon name="facebook" color="blue" size="large" /> AD</h3>
                  </Table.Cell>
                  <Table.Cell width="1">
                    <Icon name="instagram" color="pink" />
                    <Icon name={getIcon(_.get(ad, 'objectType'))} color="pink" />
                  </Table.Cell>
                  <Table.Cell width="1">
                    <Image src={_.get(ad, 'thumbnail')} size="mini" />
                  </Table.Cell>
                  <Table.Cell width="3">
                    <h4>AD Campaign:</h4>
                    <h5>AD Name:</h5>
                  </Table.Cell>
                  <Table.Cell width="7">
                    <p>{campaignName}</p>
                    <p>{adName}</p>
                  </Table.Cell>
                  <Table.Cell width="2">
                    <Button fluid color="pink" icon labelPosition="left" onClick={() => unlinkAd(_.get(ad, 'id'))}>
                      <Icon name="unlinkify" />
                    Unlink
                    </Button>
                  </Table.Cell>
                </Table.Row>
              </Table>
            </Card.Content>
          </Card>
        );
      },
      )

    }
  </div>
);

ExistingAds.propTypes = {
  ads: PropTypes.array.isRequired,
  unlinkAd: PropTypes.func.isRequired,
};

export default ExistingAds;



/** WEBPACK FOOTER **
 ** ./src/containers/view-asset-page/existing-ads.js
 **/